export default __webpack_public_path__ + "static/media/auto-repair.38b2f2aa.svg";